import React, { memo } from 'react'

export const RelatedUserLink = memo(
  ({ relatedUserId, relatedUserName, cityId }) => {
    if (!relatedUserId) return null
    return (
      <a
        href={`/dashboard/cities/${cityId}/ambassadors/${relatedUserId}`}
        target="_blank"
        rel="noreferrer"
      >
        {relatedUserName}
      </a>
    )
  },
)

export const RelatedMissionLink = memo(({ relatedMissionId }) => {
  if (!relatedMissionId) return null
  return (
    <a
      href={`/dashboard/mission/${relatedMissionId}`}
      target="_blank"
      rel="noreferrer"
    >
      Link
    </a>
  )
})

export const RelatedCityLink = memo(({ relatedCityId, relatedCityName }) => {
  if (!relatedCityId) return null
  return (
    <a
      href={`/dashboard/cities/${relatedCityId}`}
      target="_blank"
      rel="noreferrer"
    >
      {relatedCityName || 'id: ' + relatedCityId}
    </a>
  )
})

export const RelatedCampaignLink = memo(
  ({ relatedCampaign, comments, classes }) => {
    const { id, name } = relatedCampaign

    return !id ? (
      <p>{`${comments} UNKNOWN?.`}</p>
    ) : (
      <p>
        {comments}
        <a
          href={`/dashboard/campaigns/${id}/master-schedule`}
          target="_blank"
          className={classes.link}
          rel="noreferrer"
        >
          {name}
        </a>
      </p>
    )
  },
)
